import applyConfigBlockAudio from './components/Blocks/Audio';
import applyConfigBlockButton from './components/Blocks/Button';
import applyConfigBlockCarousel from './components/Blocks/Carousel';
import applyConfigBlockCustomSearch from './components/Blocks/CustomSearch';
import applyConfigBlockDateShare from './components/Blocks/DateShare';
import applyConfigBlockDivider from './components/Blocks/Divider';
import applyConfigBlockEventInfo from './components/Blocks/EventInfo';
import { DateSchemaExtender } from './components/Blocks/Form/DateSchemaExtender';
import { NumberSchemaExtender } from './components/Blocks/Form/NumberSchemaExtender';
import { withSelectDefaultValue } from './components/Blocks/Form/selectDefaultValue';
import { TextAreaSchemaExtender } from './components/Blocks/Form/TextAreaSchemaExtender';
import { TextSchemaExtender } from './components/Blocks/Form/TextSchemaExtender';
import applyConfigBlockGovernmentNumbers from './components/Blocks/GovernmentNumbers';
import applyConfigBlockGroupButton from './components/Blocks/GroupButton';
import applyConfigBlockImageList from './components/Blocks/ImageList';
import applyConfigBlockLegacyHTML from './components/Blocks/LegacyHTML';
import applyConfigBlockLinkMap from './components/Blocks/LinkMap';
import applyConfigBlockListingSelection from './components/Blocks/ListingSelection';
import applyConfigBlockPublicConsultationsListing from './components/Blocks/PublicConsultationsListing';
import applyConfigBlockResponsiveContent from './components/Blocks/ResponsiveContent';
import applyConfigBlockSectionDescription from './components/Blocks/SectionDescription';
import applyConfigBlockSectionSubtitle from './components/Blocks/SectionSubtitle';
import applyConfigBlockSectionTitle from './components/Blocks/SectionTitle';
import applyConfigBlockServiceChannels from './components/Blocks/ServiceChannels';
import applyConfigBlockSpacing from './components/Blocks/Spacing';
import applyConfigBlockSubtitle from './components/Blocks/Subtitle';
import applyConfigBlockTextToSpeech from './components/Blocks/TextToSpeech';
import { applyConfigBlockVideoContent } from './components/Blocks/VideoContent';
import AudioView from './components/View/AudioView';
import EventView from './components/View/EventView';
import FileView from './components/View/FileView';
import ImageView from './components/View/ImageView';
import JavaScriptView from './components/View/JavaScriptView';
import LinkView from './components/View/LinkView';
import applyConfigAddon from './config';

import imageSVG from '@plone/volto/icons/image.svg';

const applyConfig = (config) => {
  config.settings = {
    ...config.settings,
    // Remove a paleta de colocar estilo do volto-block-style.
    pluggableStylesBlocksWhitelist: ['none'],
  };

  // Correção para arquivos privados (401/403) acessados via @@display-file ou @@download.
  // Redireciona para a URL base do conteúdo.
  // O middleware roda antes do filesMiddleware do Volto e redireciona acessos
  // não autorizados ao @@display-file para a página "Conteúdo Restrito".
  if (typeof __SERVER__ !== 'undefined' && __SERVER__) {
    // eslint-disable-next-line global-require
    const displayFileMiddleware =
      require('./express-middleware/displayFile').default;
    config.settings.expressMiddleware = [
      displayFileMiddleware(),
      ...(config.settings.expressMiddleware || []),
    ];
  }
  // Define os ícones do control panel.
  config.settings.controlPanelsIcons = {
    ...config.settings.controlPanelsIcons,
    'image-size-properties': imageSVG,
    'audit-log': 'history',
  };

  config.views = {
    ...config.views,
    contentTypesViews: {
      ...config.views.contentTypesViews,
      Audio: AudioView,
      File: FileView,
      Image: ImageView,
      Event: EventView,
      JavaScript: JavaScriptView,
    },
    // FIXME: https://github.com/plone/volto/issues/7984
    layoutViews: {
      link_redirect_view: LinkView,
    },
  };

  // Configura bloco de texto para abrir na aba bloco.
  config.blocks.blocksConfig = {
    ...config.blocks.blocksConfig,
    slate: {
      ...config.blocks.blocksConfig.slate,
      sidebarTab: 1,
    },
  };

  applyConfigBlockButton(config);
  applyConfigBlockGroupButton(config);
  applyConfigBlockDateShare(config);
  applyConfigBlockDivider(config);
  applyConfigBlockSpacing(config);
  applyConfigBlockGovernmentNumbers(config);
  applyConfigBlockImageList(config);
  applyConfigBlockResponsiveContent(config);
  applyConfigBlockSectionDescription(config);
  applyConfigBlockSectionSubtitle(config);
  applyConfigBlockSectionTitle(config);
  applyConfigBlockServiceChannels(config);
  applyConfigBlockSubtitle(config);
  applyConfigBlockListingSelection(config);
  applyConfigBlockCarousel(config);
  applyConfigBlockCustomSearch(config);
  applyConfigBlockTextToSpeech(config);
  applyConfigBlockEventInfo(config);
  applyConfigBlockVideoContent(config);
  applyConfigBlockLinkMap(config);
  applyConfigBlockPublicConsultationsListing(config);
  applyConfigBlockLegacyHTML(config);
  applyConfigBlockAudio(config);

  // Customização: registra o extensor de schema para campos do tipo Number,
  // adicionando a opção de configurar um placeholder no campo numérico.
  config.blocks.blocksConfig.form.fieldTypeSchemaExtenders = {
    ...config.blocks.blocksConfig.form.fieldTypeSchemaExtenders,
    number: NumberSchemaExtender,
    text: TextSchemaExtender,
    textarea: TextAreaSchemaExtender,
    date: DateSchemaExtender,
  };

  // Customização: adiciona a opção de valor padrão aos campos do tipo lista.
  config.blocks.blocksConfig.form.fieldSchema = withSelectDefaultValue(
    config.blocks.blocksConfig.form.fieldSchema,
  );

  return applyConfigAddon(config);
};

export default applyConfig;
